module.exports = "<p>\r\n    modal works!\r\n  </p>\r\n  "